<template>
    <fieldset>
        <legend>{{Language.say('settings.layout.reading_pane')}}</legend>
        <div class="control-group">
            <ul class="control radio-group squared pictured">
                <li
                    v-for="(orientation, orientation_index) in orientation_list"
                    :key="orientation_index"
                    :class="orientation.class">
                    <input
                        type="radio"
                        :id="`orientation-${orientation_index}`"
                        name="orientation-mode"
                        :checked="orientation.direction == layout_controller.storage.theme_orientation"
                        tabindex="-1">
                    <label
                        @click="onSetOrientation(orientation.direction)"
                        :for="`orientation-${orientation_index}`"
                        tabindex="0">
                            {{Language.say(`settings.layout.${orientation.lang}`)}}
                    </label>
                </li>
            </ul>
        </div>
    </fieldset>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    layout_controller: Object
  })

  const orientation_list = [
    {
        class: 'side-view',
        direction: 'horizontal',
        lang: 'side_view'
    },
    {
        class: 'bottom-view',
        direction: 'vertical',
        lang: 'bottom_view'
    },
    {
        class: 'top-view',
        direction: 'top',
        lang: 'overlay_view'
    },
  ];

  const onSetOrientation = (mode) => {
    props.layout_controller.theme_orientation = mode;
  }
</script>